import {
    SET_APPROVAL_HISTORY_LIST
} from "./ApprovalHistoryType";

const reducers = (state = [], action: any) => {
    switch (action.type) {
        case SET_APPROVAL_HISTORY_LIST:
            return {
                ...state,
                approvalHistory: action.approvalHistory,
            };
        default:
            return state;
    }
};

export default reducers